
//获取生肖
export function getSX(){
    return ["鼠", "牛", "虎", "兔", "龙", "蛇", "马", "羊", "猴", "鸡", "狗", "猪"];
}

export function getZodiacIndexByYear(year) {
    // 2020 是鼠年。传入农历年份时，春节前后的生肖由后台年份决定。
    return ((parseInt(year) - 2020) % 12 + 12) % 12;
}

export function getSxStartByYear(name, year) {
    var sx = getSX();
    var sxIndex = sx.indexOf(name);
    if (sxIndex === -1) return 1;
    var yearIndex = getZodiacIndexByYear(year || new Date().getFullYear());
    return ((yearIndex - sxIndex + 12) % 12) + 1;
}

export function getSxNumbersByYear(name, year) {
    var start = getSxStartByYear(name, year);
    var values = [];
    for (var num = start; num <= 49; num += 12) {
        values.push(num);
    }
    return values;
}

export function getSxListByYear(year) {
    var sx = getSX();
    return sx.map(function(name) {
        return {
            name: name,
            index: getSxStartByYear(name, year),
            values: getSxNumbersByYear(name, year)
        };
    });
}

export function getNumberSxName(num, year) {
    var sx = getSX();
    var start = ((parseInt(num) - 1) % 12) + 1;
    var yearIndex = getZodiacIndexByYear(year || new Date().getFullYear());
    var sxIndex = (yearIndex - start + 1 + 12) % 12;
    return sx[sxIndex];
}

export function getNumberSxIndex(num, year) {
    var sx = getSX();
    return sx.indexOf(getNumberSxName(num, year));
}

export function getColor(value) {
    var reds = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];//红
    var blues = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];//蓝
    var greens = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];//绿
    let color = 'red';
    if (blues.indexOf(value) != -1) {
        color = 'blue';
    }
    if (greens.indexOf(value) != -1) {
        color = 'green';
    }
    return color;

}

export function getNumbers(maps, year) {

    var nums = [];
    var reds = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];//红
    var blues = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];//蓝
    var greens = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];//绿
    var sx = getSX();

    var rowcount = 0;
    var rows = [];
    for (var i = 1; i < 50; i++) {
        let color = 'red';
        if (blues.indexOf(i) != -1) {
            color = 'blue';
        }
        if (greens.indexOf(i) != -1) {
            color = 'green';
        }
        let sxName = getNumberSxName(i, year);
        let si = getNumberSxIndex(i, year);
        let map = maps[i];

        // console.log("i:",i,"si:",si);
        let item = {
            title: i,
            color: color,
            sx_txt: sxName,
            total: map ? map : 0,
            si: si,
            selected: false,
        };
        rows.push(item);
        rowcount++;

        if (rowcount > 9 || i == 49) {
            nums.push(rows);
            rows = [];
            rowcount = 0;
        }
    }

    return nums;
}

export function getTotals(nums) {

    var sx = getSX();
    var tw = ["0尾", "1尾", "2尾", "3尾", "4尾", "5尾", "6尾", "7尾", "8尾", "9尾"]
    var values = []
    for (var i = 0; i < sx.length; i++) {
        values.push({
            name: sx[i],
            money: 0,
            total: 0
        })
    }

    for (var i = 0; i < tw.length; i++) {
        values.push({
            name: tw[i],
            money: 0,
            total: 0
        })
    }
    for (var j = 0; j < nums.length; j++) {
        var items = nums[j];
        for (var x = 0; x < items.length; x++) {
            var si = parseInt(items[x].si);
            var t = Number(items[x].total) || 0;
            var total = values[si].total + t;
            values[si].total = total;
            var tt = items[x].title + "";
            if (tt.length > 1) {
                tt = tt.substring(1, 2);
            }
            var start = 12 + parseInt(tt);
            var wt = values[start].total + t;
            values[start].total = wt;
        }
    }

    for (var y = 0; y < values.length; y++) {
        var total = values[y].total;
        if (total > 0) {
            if (y < 12) {
                values[y].money = total / 4;
            } else {
                values[y].money = total / 5;
            }
        }
    }

    return values;
}

//计算可抄底钱数...
export function getMoney(nums, total, averagePrice, average) {
    var moneys = [];
    var new_total = total;
    var chi = 0;
    for (var i = 0; i < nums.length; i++) {
        let items = nums[i];
        for (var j = 0; j < items.length; j++) {
            let item = items[j];
            let item_total = Number(item.total) || 0;
            if (item_total == 0) continue;
            if (item_total > averagePrice) {
                chi = chi + averagePrice;
                let index = (i + 1) * j;
                let douyu = item_total - averagePrice;
                new_total = new_total - douyu;
                item.douyu = douyu;
                moneys.push(item);
                // console.log("index:",index,"total:",item_total,"douyu:",item_total-averagePrice);
            } else {
                chi = chi + item_total;
                item.douyu = 0;
                moneys.push(item);

            }
        }
    }
    var buy_price = parseInt(new_total / average);

    return {
        moneys: moneys,
        total: new_total,
        buy_price: buy_price,
        chi: chi,
    };
}
